<template>
    <!--产出消耗tab-->
    <div>
        <!--头部-->
        <div class="flex0">
            <el-select style="width: 145px"  class="marr4" v-model="isAccountTime" size="mini" filterable :placeholder="$t('form_please_select')">
                <el-option
                        v-for="item in timeType"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-date-picker
                    class="marr4"
                    size="mini"
                    v-model="begin_time"
                    formt="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 15%"
                    :placeholder="$t('promanagement_startDate')"　>
            </el-date-picker>
            <el-date-picker
                    class="marr4"
                    size="mini"
                    v-model="end_time"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 15%"
                    :placeholder="$t('promanagement_endDate')"　>
            </el-date-picker>
            <el-input class="marr4" style="width: 15%" v-model="vcName" :placeholder="$t('promanagement_search_for_product_name_or_batch_number')"　 clearable size="mini"></el-input>
            <el-button  icon="el-icon-search" circle  @click="searchData" size="mini"></el-button>
            <!-- <el-button  type="primary"  :class="baseerp+'btn'" @click="feedDialog">投料</el-button>-->
            <el-button  type="primary"  :class="baseerp+'btn'" @click="produceDialog" :disabled="disabled" size="mini">{{$t('promanagement_produce')}}</el-button>
            <el-button  type="primary"  :class="baseerp+'btn'" @click="returnDialog" :disabled="disabled" size="mini">{{$t('promanagement_consumption_refund')}}</el-button>
            <el-button  type="primary"  :class="baseerp+'btn'"   size="mini"  @click.stop="lookreport">{{$t('promanagement_produce_daily_report')}}</el-button>
        </div>
        <div class="mrb20">
        </div>
        <!--列表-->
        <div>
            <el-table
                    border
                    ref="table"
                    class="mrt10"
                    size="mini"
                    :data="tableData"
                    :height="tableHeight"
                    :header-cell-style="{background:'#eef1f6',color:'#000'}"
                    :highlight-current-row="highlightCurrentRow"
            >
                <el-table-column
                        prop="i_id"
                        label="ID"
                        width="90"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="vc_pzname"
                        :label="$t('promanagement_raw_materials/finished_products')"
                        show-overflow-tooltip
                        min-width="180">
                </el-table-column>
                <el-table-column
                        prop="vc_no"
                        :label="$t('promanagement_serial_number/production_batch_number')"
                        min-width="110"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        :label="$t('promanagement_do_you_want_to_test_it')"
                        width="50"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.i_ischeck==1" style="color: #03cb45">✔</span>
                        <span v-else style="color: red">✖</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="$t('promanagement_test_results')"
                        width="80"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.i_ischeck==1" :class="[scope.row.i_hystate==1||scope.row.i_hystate==2?'lvzt':(scope.row.i_hystate==-1?'hongzt':'juzt')]">{{scope.row.i_hystate==0?$t('promanagement_to_be_inspected'):(scope.row.i_hystate==1?$t('promanagement_qualified'):(scope.row.i_hystate==-1?$t('promanagement_unqualified'):$t('promanagement_premium_product')))}}</span>
                        <span v-else>{{$t('form_none')}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="$t('promanagement_laboratory_test_report')"
                        width="80"
                >
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="seeimg(scope.row)" v-if="!!scope.row.vc_hyfile" style="color:#37b9f5;font-weight: 600">点击查看</el-button>
                        <span v-else>{{$t('form_none')}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="vc_unit"
                        :label="$t('form_metering')"
                        width="70">
                </el-table-column>
                <el-table-column
                        prop="f_innum"
                        :label="$t('promanagement_quantity_of_feeding_materials')"
                        show-overflow-tooltip
                        width="70"
                        align="right">
                </el-table-column>
                <el-table-column
                        prop="f_innum_zb"
                        :label="$t('promanagement_100%_discount_for_feeding_quantity')"
                        show-overflow-tooltip
                        width="85"
                        align="right">
                </el-table-column>
                <el-table-column
                        prop="f_outnum"
                        :label="$t('promanagement_output_quantity')"
                        show-overflow-tooltip
                        width="70"
                        align="right">
                </el-table-column>
                <el-table-column
                        prop="f_outnum_zb"
                        :label="$t('promanagement_output_converted_to_100%_quantity')"
                        show-overflow-tooltip
                        width="85"
                        align="right">
                </el-table-column>
                <el-table-column
                        prop="dt_tltime"
                        :label="$t('promanagement_input_output_time')"
                        show-overflow-tooltip
                        min-width="180">
                </el-table-column>
                <el-table-column
                        prop="vc_bc"
                        :label="$t('promanagement_classes')"
                        width="70">
                </el-table-column>
                <el-table-column
                        prop="vc_scxname"
                        :label="$t('promanagement_production_pine')"
                        width="70"
                        show-overflow-tooltip>
                </el-table-column>

                <el-table-column
                        prop="vc_note"
                        :label="$t('form_notes')"
                        width="50"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="dt_createtime"
                        :label="$t('form_enter_time')"
                        show-overflow-tooltip
                        min-width="180">
                </el-table-column>
                <el-table-column
                        prop="dt_accounttime"
                        :label="$t('promanagement_accountingTime')"
                        show-overflow-tooltip
                        min-width="180">
                </el-table-column>
                <el-table-column
                        prop="vc_lruname"
                        :label="$t('form_input_person')"
                        width="80"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        :label="$t('form_operate')"
                        width="50">
                    <template slot-scope="scope">
                        <el-button @click="edit(scope.row)" type="text" size="small">{{$t('button_edit')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    class="fr page"
                    background
                    layout="prev, pager, next"
                    @current-change="pageCurrentChange"
                    :current-page.sync="currentPage"
                    :total="tableTotal"
                    :page-size="pageSize">
            </el-pagination>
        </div>
        <!--投料dialog-->
<!--        <div :class="baseerp+'div'">-->
<!--            <el-dialog-->
<!--                     width="1000px"-->
<!--                    :title="title"-->
<!--                    :visible.sync="feedDialogVisible"-->
<!--                    :close-on-click-modal="false"-->
<!--                    @close="cancelDialog"-->
<!--                    v-if="feedDialogVisible">-->
<!--                <feeding-form :feeding="feeding" @close="cancelDialog" @getConsumeList="getConsumeList" @addLine="addLine"></feeding-form>-->
<!--            </el-dialog>-->
<!--        </div>-->
        <!--产出dialog-->
        <div :class="baseerp+'div'">
            <el-dialog class="produceform"
                     width="98%"
                    :title="title"
                    :visible.sync="produceDialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="produceDialogVisible">
                <produce-form :produce="produce" @close="cancelDialog" @getConsumeList="getConsumeList"></produce-form>
            </el-dialog>
        </div>
        <!--在线退回dialog-->
        <div :class="baseerp+'div'">
            <el-dialog
                     width="1000px"
                    :title="title"
                    :visible.sync="returnDialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="returnDialogVisible">
                <consumption-return :returnlist="returnlist" @close="cancelDialog" @getConsumeList="getConsumeList" ></consumption-return>
            </el-dialog>
        </div>
        <div :class="baseerp+'div'">
            <el-dialog

                    width="500px"
                    :title="$t('promanagement_image_viewer')"
                    :visible.sync="tupiandialog"
                    :close-on-click-modal="false"
                    @close="tupiandialog=false"
                    v-if="tupiandialog">
                <div style="display: flex;flex-wrap: wrap">
<!--                    <div style="width: 100px;height: 100px;" >-->
                        <el-image style="width: 120px;height: 120px;"
                                  v-for="(item, index) in fileList" :key="index" :src="filehead+item.vc_path"
                                  :preview-src-list="[filehead+item.vc_path]"
                                  slot="reference" :alt="filehead+item.vc_path"
                                  :z-index="9999"
                        >
                        </el-image>
<!--                        <image :src="filehead+item.vc_path"/>-->
<!--                    </div>-->

                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="tupiandialog=false">{{$t('button_close')}}</el-button>
                </span>
<!--                <consumption-return :returnlist="returnlist" @close="cancelDialog" @getConsumeList="getConsumeList" ></consumption-return>-->
            </el-dialog>
        </div>
        <!--表报 -->
        <div class="">
            <reportdialog  ref="mydialog"   ></reportdialog>
            <eDialog ref="eDialog" :activePage="activePage"></eDialog>
        </div>
        <!--分页-->
        <!--<div>

        </div>-->
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    // import FeedingForm from "./FeedingForm";
    import ProduceForm from "./ProduceForm";
    import ConsumptionReturn from "./ConsumptionReturn";
    import reportdialog from "@/components/dialog"; // 错误dialog
    import eDialog from "@/components/eDialog"; // dialog
    import {mapActions} from "vuex";
    import {file_root} from "@/utils/baseUrl.js"
    // import ReturnList from "./ReturnList";
    export default {
        name: "ConsumeList",
        components: {ProduceForm,ConsumptionReturn,reportdialog,eDialog},
        props:{
            formvalue:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                timeType:[  {i_id:0,vc_name:this.$t('promanagement_search_by_entry_time')},
                    {i_id:1,vc_name:this.$t('promanagement_search_by_accounting_time')}],
                isAccountTime:0,
                begin_time:"",
                end_time:"",
                vcName:"",
                tupiandialog:false,
                activePage:"report/res/spread.vue",
                disabled:false,
                //消耗退回
                returnlist:{},
                returnDialogVisible:false,
                //产出
                produce:{},
                produceDialogVisible:false,
                //投料
                //feeding:{},
                //feedDialogVisible:false,
                //外
                taskDa:{},
                taskId:"",
                pageSize:13,
                currentPage:1,
                tableTotal:0,
                i_id:"",
                title:"",
                titleID:"",
                highlightCurrentRow:true,
                tableData:[],
                baseerp:"",
                mid:0,
                tableHeight:0,
                fileList:[],
                filehead:''
            }
        },

        watch:{
            formvalue:{
                handler(){
                   //console.log(this.formvalue,"产出消耗-从tasklist窜过来");
                    if (this.formvalue){
                        if(this.i_id!=this.formvalue.i_id) {
                            if ((this.formvalue.i_id ?? '' !== '') && (this.formvalue.i_id != 0)) {
                                this.taskDa = this.formvalue.value;
                                this.taskId = this.formvalue.i_id;
                                this.mid=this.formvalue.i_mid;
                                //this.i_type = this.formvalue.i_type;
                                //this.apptitle = this.formvalue.title;
                                this.getConsumeList();
                                // console.log(this.taskDa,this.taskId,"this.task");
                                /*if (this.formvalue.value.dt_createtime>=this.formvalue.value.dt_starttime&&this.formvalue.value.dt_createtime<=this.formvalue.value.dt_endtime){
                                    this.disabled=false;
                                   // console.log(this.formvalue.value.dt_createtime,this.formvalue.value.dt_starttime,this.formvalue.value.dt_endtime,"check")
                                }else{
                                    this.disabled=true;
                                };250804*/
                                //console.log(this.formvalue.value.jz,"this.jz");
                                if(this.formvalue.value.jz==true){
                                    this.disabled=true;
                                }else{
                                    this.disabled=false;
                                }
                            }
                        }
                    }
                },
                immediate:true,
                deep:true
            },
        },
        mounted() {
            this.filehead=file_root
            this.baseerp=baseerp;
            this.$nextTick(function () {
                window.addEventListener('resize',this.heightAuto);
                this.heightAuto();
            });
        },
        methods: {
            seeimg(item){
                this.fileList=item.vc_hyfile.otherfiles
              this.tupiandialog=true
            },
            ...mapActions(["getCurrentMenuId"]),
            heightAuto(){
                this.tableHeight = window.innerHeight - this.$refs.table.$el.clientTop - 280;
            },
            // addLine(val){ //添加行数
            //     console.log(val,"vallll")
            //     var newValue = {
            //         i_id: val.i_id,
            //         vc_pzname: val.vc_pzname,
            //         vc_no:  val.vc_no,
            //         vc_unit:  val.vc_unit,
            //         f_innum: val.f_innum,
            //         f_innum_zb: val.f_innum_zb,
            //         f_outnum:  val.f_outnum,
            //         f_outnum_zb: val.f_outnum_zb,
            //         dt_tltime: val.dt_tltime,
            //         vc_bc: val.vc_bc,
            //         vc_scxname: val.vc_scxname,
            //         vc_note: val.vc_note,
            //         dt_createtime: val.dt_createtime,
            //         vc_lrnname: val.vc_lrnname,
            //         c_type: val.c_type,
            //         i_pid: val.i_pid
            //     };
            //     //添加新的行数
            //     this.tableData.unshift(newValue);
            // },



            //报表
            async lookreport() {

                if(this.formvalue.title==null||this.formvalue==null){
                    this.$message.error(this.$t('promanagement_please_select_the_desired_option_to_add_the_left_side_order'))
                }else{

                    this.sheet={
                        taskId:this.taskId,
                        taskDa:this.taskDa,
                        i_mid:this.mid,
                        value:"",
                    };
                    //console.log(this.sheet,"统计sheet");
                    var month=this.sheet.taskDa.dt_starttime.match(/(\d{4})(\d{2})(\d{2})/).filter((item,index) => index > 0).join('-');
                    month = month.slice(0,7);
                    //console.log(month,"month");
                    var month_s=this.sheet.taskDa.dt_starttime.match(/(\d{4})(\d{2})(\d{2})/).filter((item,index) => index > 0).join('-');
                    var month_e=this.sheet.taskDa.dt_endtime.match(/(\d{4})(\d{2})(\d{2})/).filter((item,index) => index > 0).join('-');
                    //this.formonth=data.forMonth

                    let loading =this.$loading({lock:true,text:"正在加载数据,请稍候...",background:"rgba(0,0,0,0.5)"});
                    //this.$refs.eDialog.showDialog({title:"报表",btn:{f:this.btn,l:{a:{title:"a",name:"a1"}}},parm:{type:'AttMonthRpt',mid:this.$route.meta.mid},w:800,h:600});
                    document.addEventListener('click',function(e){
                        loading.close()
                    })
                    let result = await this.getCurrentMenuId({path: this.$route.path});
                    // console.log("result",result)
                    if (result.i_id !== "") {
                        this.mid = result.i_id
                        sessionStorage.setItem('mids', result.i_id)
                    } else {
                        this.mid = sessionStorage.getItem('mids')
                    }
                    //console.log(this.mid,"midddddddddd==675?");

                    this.$refs.eDialog.showDialog({title:"产出日报",parm:{type:'DailyProductRpt',mid:this.mid,arg:{month:month,dbid:this.sheet.taskDa.i_fcid,month_e:month_e,month_s:month_s}},w:1024,h:768});

                    loading.close();


                    // console.log(data)
                    // return
                    /*let result = await this.getCurrentMenuId({path: this.$route.path});
                    if (result.i_id !== "") {
                        this.mid = result.i_id
                        sessionStorage.setItem('mids', result.i_id)
                    } else {
                        this.mid = sessionStorage.getItem('mids')
                    }
                    // console.log(this.i_kqtcid)
                    let params = {
                        kqtcId: this.kaoqini_id,
                        date:this.formonth

                    }
                    let res = await API.time(params);
                    if (res.code == 1) {
                        this.startDate=res.data.monthStartTime
                        this.endDate=res.data.monthEndTime
                        this.$refs.eDialog.showDialog({title:"产出日报",parm:{type:'DailyProductRpt',mid:675,arg:{startDate:this.startDate,endDate:this.endDate.substring(0,10),djmark:this.djmark}},w:1024,h:768});
                        loading.close();
                        // console.log(res)
                    } else if (res.code == -2) {
                        this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});

                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});

                        this.$message.error(res.message);
                    }*/
                }

            },

            btn(){
                //console.log("123123")
            },

            //点击退回
            returnDialog(){
                if(this.formvalue.title==null||this.formvalue==null){
                  this.returnDialogVisible=false;
                  this.$message.error(this.$t('promanagement_please_select_the_desired_option_to_add_the_left_side_order'))
                }else{
                     this.title=this.$t('promanagement_consumption_refund');
                     this.titleID="xhth";
                     this.highlightCurrentRow=true;
                     this.returnlist={
                         taskId:this.taskId,
                         taskDa:this.taskDa,
                         value:"",
                         jz:this.formvalue.value.jz,
                     };
                     // console.log(this.returnlist,"returnlist");
                     this.returnDialogVisible=true;
                }
             },

            //点击产出
            produceDialog(){
                if(this.formvalue.title==null||this.formvalue==null){
                    this.produceDialogVisible=false;
                    this.$message.error(this.$t('promanagement_please_select_the_desired_option_to_add_the_left_side_order'))
                }else{
                    this.title=this.$t('promanagement_add_output');
                    this.titleID="tjcc";
                    this.highlightCurrentRow=true;
                    this.produce={
                        taskId:this.taskId,
                        taskDa:this.taskDa,
                        c_type:16,
                        i_id:0,
                        value:"",
                        page_size:1,
                        i_mid:this.mid,
                        jz:this.formvalue.value.jz,
                        vc_pricing_unit:this.formvalue.value.vc_pricing_unit,
                    };
                    // console.log(this.produce,"produce");
                    this.produceDialogVisible=true;
                }
            },



            //点击投料
            // feedDialog(){
            //     if(this.formvalue.title==null||this.formvalue==null){
            //         this.feedDialogVisible=false;
            //         this.$message.error("请选择要的添加左侧单！")
            //     }else{
            //         this.title="添加投料";
            //         this.highlightCurrentRow=true;
            //         this.feeding={
            //             taskId:this.taskId,
            //             taskDa:this.taskDa,
            //             c_type:7,
            //             i_id:0,
            //             value:"",
            //             page_size:1,
            //         };
            //         console.log(this.feeding,"feeding");
            //         this.feedDialogVisible=true;
            //     }
            // },

            //编辑
            edit(row){
                // console.log(row,"row");
                this.title=this.$t('promanagement_edit_output');
                this.titleID="bjcc";
                    this.produce={
                        taskId:this.taskId,
                        taskDa:this.taskDa,
                        i_id:row.i_id,
                        value:row,
                        title:this.$t('promanagement_edit_output'),
                        titleID:"bjcc",
                        page_size:this.currentPage,
                        i_mid:this.mid,
                    };
                    // console.log(this.produce,"编辑produce");
                    this.produceDialogVisible=true;

                // this.highlightCurrentRow=true;
                // if (row.c_type==7){
                //     this.title="编辑投料";
                //     this.feeding={
                //         taskId:this.taskId,
                //         taskDa:this.taskDa,
                //         i_id:row.i_id,
                //         value:row,
                //         title:"编辑投料",
                //         page_size:this.currentPage,
                //     };
                //     console.log(this.feeding,"编辑feeding");
                //     this.feedDialogVisible=true;
                // }else if (row.c_type==16){
                //     this.title="编辑产出";
                //     this.produce={
                //         taskId:this.taskId,
                //         taskDa:this.taskDa,
                //         i_id:row.i_id,
                //         value:row,
                //         title:"编辑产出",
                //         page_size:this.currentPage,
                //     };
                //     console.log(this.produce,"编辑produce");
                //     this.produceDialogVisible=true;
                // }
            },

            // cancelDialog(){
            //     if (this.title=="添加投料"||this.title=="编辑投料"){
            //         this.feedDialogVisible=false;
            //         this.highlightCurrentRow=true;
            //     }else if(this.title=="添加产出"||this.title=="编辑产出"){
            //         this.produceDialogVisible=false;
            //         this.highlightCurrentRow=true;
            //     }else if (this.title=="消耗退回"){
            //         this.returnDialogVisible=false;
            //     }
            // },
            cancelDialog(){
                if (this.titleID=="tjtl"||this.titleID=="bjtl"){
                    this.feedDialogVisible=false;
                    this.highlightCurrentRow=true;
                }else if(this.titleID=="tjcc"||this.titleID=="bjcc"){
                    this.produceDialogVisible=false;
                    this.highlightCurrentRow=true;
                }else if (this.titleID=="xhth"){
                    this.returnDialogVisible=false;
                }
            },
            searchData(){
                // console.log(this.vcName,this.begin_time,this.end_time,"searchData")
                if(this.formvalue.title==null||this.formvalue==null){
                    this.$message.error(this.$t('promanagement_please_select_the_desired_option_to_add_the_left_side_order'))
                    return
                }
                this.getConsumeList();
            },
            //调用产出消耗列表接口
            async getConsumeList(){
                let param={
                    i_mid: this.mid,
                    i_id:this.formvalue.i_id,
                    page_size:this.currentPage,
                    page_count:13,
                    flag:1,
                    begin_time:this.begin_time?this.begin_time:'',
                    end_time:this.end_time?this.end_time:'',
                    vc_name:this.vcName,
                    isAccountTime:this.isAccountTime,
                };
                let res=await API.getConsumeList(param);
                if ( res.code == 1 ){
                    this.tableData=res.data;
                    this.tableTotal=res.count;
                    // console.log(this.tableData,"this.tableData")
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            //分页
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.getConsumeList();
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize',this.heightAuto)
        },
    }
</script>

<style lang="scss" scoped>
    .mrt10{
        margin-top: 6px;
    }
    .marr4{
        margin-right: 6px;
    }
    .mrb20{
        margin-bottom: 8px;
    }

    .fr{
        float: right;
    }

    /deep/{
        .produceform{
            .el-dialog{
                min-width: 1265px;
            }

        }
        .el-dialog__body{
            word-break:unset;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
        .page {
            padding: 6px;
        }
    .juzt{
        color: #f08c00;
        font-weight: 600;
    }
    .lvzt{
        color: #3cb44b;
        font-weight: 600;

    }
        /deep/.tupian .el-image{
            z-index:99999 !important;
        }
    .hongzt{
        color: #fa5050;
        font-weight: 600;

    }
    }
</style>